import React, { useEffect, useState, useCallback, useContext } from 'react';
import {
    Button,
    Select,
    DatePicker,
    Form,
    message,
    Dropdown,
    Menu,
    Popconfirm,
    Modal,
    Typography,
    Tag,
    Upload,
    Radio,
    Input,
    Col,
    Space,
    Tooltip
} from 'antd';
import { Icon } from '@ant-design/compatible';
import time from '../../utils/time'
import chart from '../../utils/chart'
import moment from "moment";
import { Fileuploader } from '@ap-evolved/evolved-ui.ui.fileuploader'
import { v4 as uuidv4 } from 'uuid'
import styles from './styles'
import UploadModal from './UploadModal'
import ExportModal from './ExportModal'
import PropTypes from 'prop-types'

const MenuOptions = () => {

    /* useState */
    const [showExportModal, setShowExportModal] = useState(false)
    const [showUploadModal, setShowUploadModal] = useState(undefined)

    /* constants */
    // menu options 
    const menu = (
        <Menu>
            <Menu.Item
                key={`upload`}
                onClick={() => { setShowUploadModal(true) }}
            >
                <Icon type='plus' />
                {` Upload new data`}

            </Menu.Item>
            <Menu.Item
                key={`download-all`}
                onClick={() => { setShowExportModal(true) }}
            >
                <Icon type='export' />
                {` Export dashboard`}
            </Menu.Item>

        </Menu>
    )

    return (
        <>
            {<Dropdown
                onClick={(event) => { event.stopPropagation() }}
                overlay={menu}
                placement="bottomLeft"
                trigger={['click']}
            >
                <Button shape="circle" icon={<Icon type="menu" />}></Button>
            </Dropdown>}
            <UploadModal
                showModal={showUploadModal}
                setShowModal={setShowUploadModal}
            />
            <ExportModal
                showModal={showExportModal}
                setShowModal={setShowExportModal}
            />
        </>
    )

}

MenuOptions.propTypes = {}
MenuOptions.defaultProps = {}

export default MenuOptions